var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3385 10.0013C18.3385 14.6037 14.6076 18.3346 10.0052 18.3346C5.40284 18.3346 1.67188 14.6037 1.67188 10.0013C1.67188 5.39893 5.40284 1.66797 10.0052 1.66797C14.6076 1.66797 18.3385 5.39893 18.3385 10.0013ZM10.0052 9.16797C10.4654 9.16797 10.8385 9.54106 10.8385 10.0013V14.1687C10.8385 14.6289 10.4654 15.002 10.0052 15.002C9.54497 15.002 9.17188 14.6289 9.17188 14.1687V10.0013C9.17188 9.54106 9.54497 9.16797 10.0052 9.16797ZM10.0052 7.5013C10.4654 7.5013 10.8385 7.12821 10.8385 6.66797C10.8385 6.20773 10.4654 5.83464 10.0052 5.83464C9.54497 5.83464 9.17188 6.20773 9.17188 6.66797C9.17188 7.12821 9.54497 7.5013 10.0052 7.5013Z",
    fill: "#FF6A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.adf2aff3a4654c41db1e7ab1bd66305c.svg";
export { ForwardRef as ReactComponent };